<template>
  <div>
    <checklist-form :checklistTemplateObj="checklistTemplateObj" @update="onSuccessHandler" :token="accessToken" @back="backToList"
      :defaultMappingValues="defaultMappingValues"></checklist-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  /* checklisttemplateobj will contain checklistemplateobj while creating new
    checklisttemplateobj will contain actual saved checklist obj while updating */
  props: ['module', 'propId', 'reference', 'checklistTemplateId', 'checklistTemplateObj', 'defaultMappingValues'],
  data () {
    return {
      accessToken: process.env.VUE_APP_CHECKLIST_ACCESS_TOKEN,
      moduleId: this.$route.params.id
    }
  },
  computed: {
    ...mapState(['common'])
  },
  components: {
    'checklist-form': () => import('./ChecklistForm.vue')
  },
  methods: {
    onSuccessHandler (payload) {
      if (payload.status === 'success') {
        let text = ''
        if (payload.data && payload.action === 'update') text = this.$t('message.common.updatedSuccess')
        else if (payload.data && payload.action === 'add') text = this.$t('message.common.addedSucess')
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        if (payload.action === 'add' || payload.action === 'update') this.saveChecklistData(payload.data, payload.action, payload.canClose, this.checklistTemplateObj, payload)
      } else if (payload.status === 'error') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: payload.data.response.data })
      }
    },
    saveChecklistData (checklist, action, canClose, checklistTemplateObj, payload) {
      let recordId = this.$route.params[this.propId]
      let url = ''
      let method = ''
      let text = ''
      let checklistObj = {
        related_record_id: recordId,
        form_id: checklistTemplateObj.form_id,
        checklist_id: checklist._id,
        name: payload.useAsTitleValue || checklistTemplateObj.name,
        module: this.moduleId,
        status: 1,
        checklist_progress: payload.checklistProgress || 0
      }
      if (checklist._id && action === 'update') {
        url = `checklists/${this.checklistTemplateObj.id}`
        method = 'put'
        text = this.$t('message.common.updatedSuccess')
      } else {
        url = 'checklists'
        method = 'post'
        text = this.$t('message.common.addedSucess')
      }
      // While creating we will get checklistemplateobj in this.checklistTemplateObj
      // But during update we need to get value from listOfChecklisttemplate by matching checklistTemplateObj.checklist_template_id
      if (method === 'post') {
        checklistObj = {
          ...checklistObj,
          checklist_template_id: this.checklistTemplateObj.id,
          pdftemplatepath: checklistTemplateObj.pdftemplatepath,
          templateoriginalname: checklistTemplateObj.templateoriginalname
        }
      }
      // else {
      //   let currentTemplateObj = this.common.listOfChecklistTemplates.find(x => x._id === checklistTemplateObj.checklist_template_id)
      //   if (!this.$formatter.isEmptyObject(currentTemplateObj)) {
      //     checklistObj = {
      //       ...checklistObj,
      //       checklist_template_id: currentTemplateObj.id,
      //       pdftemplatepath: currentTemplateObj.pdftemplatepath,
      //       templateoriginalname: currentTemplateObj.templateoriginalname
      //     }
      //   }
      // }
      this.$_executeApi(method, url, checklistObj)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
          if (response.data) {
            if (canClose) this.$eventBus.$emit('closeChecklistDialog')
            else this.$eventBus.$emit('setChecklistId', response.data, canClose)
          }
        })
    },
    backToList () {
      this.$eventBus.$emit('closeChecklistDialog')
    }
  }
}
</script>
